export const highlights = [
  "atom-one-dark",
  "darcula",
  "github",
  "monokai-sublime",
  "hybrid",
  "night-owl",
  "srcery",
  "idea",
  "shades-of-purple",
  "xcode",
];
